import React, { useState } from "react";

import { apiURL } from "../../api/index";

function ProductModal(props) {
  const [category, setCategory] = useState("");
  const [title, setTitle] = useState("");
  const [image, setImage] = useState(null);
  const [price, setPrice] = useState("");
  const [description, setDescription] = useState("");
  const [message, setMessage] = useState("");
  const [isProductAddedSuccessfully, setIsProductAddedSuccessfully] =
    useState(false);

  const createProduct = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData();
      formData.append("category", category);
      formData.append("title", title);
      formData.append("image", image);
      formData.append("price", price);
      formData.append("description", description);

      const res = await fetch(`${apiURL}/createproduct`, {
        method: "POST",
        body: formData,
      });

      const data = await res.json();

      if (data.message === "Product Added") {
        setMessage("The Product Has Been Added Successfully!");
        setIsProductAddedSuccessfully(true);
        setTimeout(() => {
          props.closeProductModal();
        }, 2000);
        setCategory("");
        setImage(null);
        setTitle("");
        setPrice("");
        setDescription("");
      } else if (data.message === "Invalid Details") {
        setMessage("Invalid Details OR File Type Error!");
        setIsProductAddedSuccessfully(false);
      }
    } catch (error) {
      setMessage("Unable To Send Data Due To Network Error!");
      console.log(error);
    }
  };

  const updateProduct = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData();
      formData.append("category", category);
      formData.append("title", title);
      formData.append("image", image);
      formData.append("price", price);
      formData.append("description", description);

      const res = await fetch(`${apiURL}/updateproduct/${props.productId}`, {
        method: "POST",
        body: formData,
      });

      const data = await res.json();

      if (data.message === "Product Updated") {
        setMessage("The Product Has Been Updated Successfully!");
        setIsProductAddedSuccessfully(true);
        setTimeout(() => {
          props.closeProductModal();
        }, 2000);
        setCategory("");
        setImage(null);
        setTitle("");
        setPrice("");
        setDescription("");
      } else {
        setMessage("Invalid Details OR File Type Error!");
        setIsProductAddedSuccessfully(false);
      }
    } catch (error) {
      setMessage("Unable To Send Data Due To Network Error!");
      console.log(error);
    }
  };

  return (
    <>
      <div
        className={
          isProductAddedSuccessfully
            ? "bg-green-600 text-white font-primary text-center"
            : "bg-amber-600 text-white font-primary text-center"
        }
      >
        {message}
      </div>
      <div className="absolute w-[100%] h-[100vh] bg-white bg-opacity-[0.6] justify-center items-center flex">
        <form
          encType="multipart/form-data"
          className="flex flex-col w-96 h-[60vh] mx-auto justify-center items-left p-5 bg-primary text-white rounded-sm"
        >
          <select
            name="category"
            className="text-primary my-2 p-2 outline-none"
            onChange={(e) => setCategory(e.target.value)}
          >
            <option value="">--Select Category--</option>
            <option value="Gadgets">Gadgets</option>
            <option value="Tires">Tires</option>
            <option value="Motors">Motors</option>
            <option value="HeadLights">HeadLights</option>
            <option value="Batteries">Batteries</option>
            <option value="Helmets">Helmets</option>
          </select>
          <input
            onChange={(e) => setTitle(e.target.value)}
            className="my-2 p-2 text-black outline-none"
            type="text"
            placeholder="Product Title..."
            name="title"
          />

          <input
            className="my-2 p-2 outline-none"
            onChange={(e) => setImage(e.target.files[0])}
            type="file"
            name="image"
          />
          <input
            onChange={(e) => setPrice(e.target.value)}
            className="my-2 p-2 text-black outline-none"
            type="number"
            placeholder="Product Price..."
            name="price"
          />

          <textarea
            onChange={(e) => setDescription(e.target.value)}
            className="my-2 p-2 text-black outline-none"
            style={{ resize: "vertical" }}
            placeholder="Product Description..."
            name="description"
          />
          {props.operation === "create" ? (
            <button
              className="bg-secondary py-2 mt-2"
              onClick={(e) => createProduct(e)}
            >
              Create
            </button>
          ) : (
            <button
              className="bg-secondary py-2 mt-2"
              onClick={(e) => updateProduct(e)}
            >
              Update
            </button>
          )}

          <button
            type="submit"
            className="bg-red-600 py-2 mt-2"
            onClick={props.closeProductModal}
          >
            Cancel
          </button>
        </form>
      </div>
    </>
  );
}

export default ProductModal;
